export type BotLinkState = { ok: true; url: string } | { ok: false }

declare global {
	// eslint-disable-next-line no-var
	var __PRIME_BOT__: BotLinkState | undefined
}

export function readBotLinkFromPage(): BotLinkState {
	const state = globalThis.__PRIME_BOT__
	if (state?.ok === true && typeof state.url === 'string' && state.url) {
		return state
	}
	return { ok: false }
}
